import Swiper from 'swiper/bundle';

const swiperSlide = new Swiper(".swiper.m-slide", {
  spaceBetween: 50,
  centeredSlides: true,
  grabCursor: true,
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      centeredSlides: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      loopFillGroupWithBlank: true,
    }
  },
  // ページネーションが必要なら追加
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});


const swiperFade = new Swiper(".swiper.m-fade", {
  spaceBetween: 50,
  effect: "fade",
  // centeredSlides: true,
  // grabCursor: true,
  slidesPerView: 1,
  loop: true,
  pauseOnMouseEnter: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  // ページネーションが必要なら追加
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});

